import { take, select, put, fork, cancel } from 'redux-saga/effects';
import { delay } from 'redux-saga';


import { login } from '../auth/actions';
import {
  lockDoors, lockDoorsResult, clearTooltip, setTooltip, toggleIgnitionResult, toggleIgnition, unlockTrunkResult, toggleTrunk,
} from '../devices/actions';
import { logoutButtonClick } from '../../components/Auth/actions';


function* lockDoorsTooltipSaga() {
  while (true) {
    const action = yield take([lockDoors.started.type, lockDoors.failed.type]);
    const on = yield select(state => state.devices.currentDeviceStats.centralLockOn);

    yield put({
      type: setTooltip.type,
      payload: {
        type: action.type,
        on,
      },
    });

    if (action.type === lockDoors.failed.type) {
      yield delay(7000);
      yield put({
        type: clearTooltip,
      });
    }
  }
}

function* lockDoorsResultTooltipSaga() {
  while (true) {
    const action = yield take(lockDoorsResult.type);

    yield put({
      type: setTooltip.type,
      payload: {
        type: action.payload.result ? lockDoors.done.type : lockDoors.failed.type,
        on: !action.payload.on,
      },
    });

    yield delay(7000);
    yield put({
      type: clearTooltip.type,
    });
  }
}

function* unlockTrunkTooltipSaga() {
  while (true) {
    const action = yield take([toggleTrunk.started.type, toggleTrunk.failed.type]);
    const on = yield select(state => state.devices.currentDeviceStats.unlockTrunk);

    yield put({
      type: setTooltip.type,
      payload: {
        type: action.type,
        on: !on,
      },
    });

    if (action.type === toggleTrunk.failed.type) {
      yield delay(7000);
      yield put({
        type: clearTooltip,
      });
    }
  }
}

function* unlockTrunkResultTooltipSaga() {
  while (true) {
    const action = yield take(unlockTrunkResult.type);
    yield put({
      type: setTooltip.type,
      payload: {
        type: action.payload.result ? toggleTrunk.done.type : toggleTrunk.failed.type,
        on: action.payload.on,
      },
    });

    yield delay(7000);
    yield put({
      type: clearTooltip.type,
    });
  }
}

function* toggleIgnitionTooltipSaga() {
  while (true) {
    const action = yield take([toggleIgnition.started.type, toggleIgnition.failed.type]);
    const on = yield select(state => state.devices.currentDeviceStats.centralLockOn);
    if (action.type === toggleIgnition.started.type) {
      const { body } = action.payload;
      const starting = body === JSON.stringify({ on: true });
      yield put({
        type: setTooltip.type,
        payload: {
          type: action.type,
          on: starting,
        },
      });
    } else {
      yield put({
        type: setTooltip.type,
        payload: {
          type: action.type,
          on,
        },
      });
    }

    if (action.type === toggleIgnition.failed.type) {
      yield delay(7000);
      yield put({
        type: clearTooltip,
      });
    }
  }
}

function* toggleIgnitionResultTooltipSaga() {
  while (true) {
    const action = yield take(toggleIgnitionResult.type);

    yield put({
      type: setTooltip.type,
      payload: {
        type: action.payload.result ? toggleIgnition.done.type : toggleIgnition.failed.type,
        on: action.payload.on,
      },
    });

    yield delay(7000);
    yield put({
      type: clearTooltip.type,
    });
  }
}


function* clearOnLogoutSaga() {
  while (true) {
    yield take(logoutButtonClick.type);

    yield put({
      type: clearTooltip.type,
    });
  }
}


export default function* sidebarTooltipSaga() {
  while (true) {
    yield take(login.done.type);

    const lockDoorsActiveSaga = yield fork(lockDoorsTooltipSaga);
    const lockDoorsResultActiveSaga = yield fork(lockDoorsResultTooltipSaga);
    const toggleIgnitionActiveSaga = yield fork(toggleIgnitionTooltipSaga);
    const toggleIgnitionResultActiveSaga = yield fork(toggleIgnitionResultTooltipSaga);
    const unlockTrunkActiveSaga = yield fork(unlockTrunkTooltipSaga);
    const unlockTrunkResultActiveSaga = yield fork(unlockTrunkResultTooltipSaga);
    const clearOnLogountActiveSaga = yield fork(clearOnLogoutSaga);

    yield take(logoutButtonClick.type);

    yield cancel(lockDoorsActiveSaga);
    yield cancel(lockDoorsResultActiveSaga);
    yield cancel(toggleIgnitionActiveSaga);
    yield cancel(toggleIgnitionResultActiveSaga);
    yield cancel(unlockTrunkActiveSaga);
    yield cancel(unlockTrunkResultActiveSaga);
    yield cancel(clearOnLogountActiveSaga);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/sidebar-tooltip/index.js